__turbopack_context__.v({
  "checkIcon": "yu1wsG_checkIcon",
  "compact": "yu1wsG_compact",
  "iconWrapper": "yu1wsG_iconWrapper",
  "label": "yu1wsG_label",
  "root": "yu1wsG_root",
});
